import gql from 'graphql-tag';

export const deleteMonLogType = gql`
  mutation deleteMonLogType($id: String) {
    deleteMonLogType(id: $id)
  }
`;
